import React from 'react';
import ReactDOM from 'react-dom';
import Union from './Union';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    < Union />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();